import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { getFrontEnv } from 'admin/utils';
import { openAlertModal } from 'admin/actions/alert-modal';
import { showLoadingSpinner, hideLoadingSpinner } from 'admin/actions/loading-spinner';
import { Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap';
import { login } from 'admin/actions/login';
import OnePane from '../../templates/OnePane';

const LabelText = styled.div`
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
  color: white;
  background-color: red;
  font-weight: 600;
`;

class Login extends Component {
  constructor(props) {
    super(props);
    const queryParams = queryString.parse(props.location.search);
    this.state = {
      organization: queryParams.organization || '',
      email: queryParams.email || '',
      password: '',
      password_visible: false,
      isAlreadyRegistered: queryParams.is_already_registered,
    };
    this.env = getFrontEnv();
  }

  invalidParamsMessage(params) {
    const name = { organization: '組織コード', email: 'Eメールアドレス', password: 'パスワード' };
    return params.map(p => name[p]).filter(p => !!p).join('と');
  }

  componentWillUpdate(newProps, newState) {
    if (newProps.api_error !== this.props.api_error) {
      this.props.hideLoadingSpinner();
      const getMessage = (e) => {
        const { errors, type, message } = e;
        switch (type) {
          case 'invalid_parameters':
            return `${this.invalidParamsMessage(errors.invalid)}に誤りがあります。入力内容をご確認ください。`;
          default:
            return message || '処理に失敗しました。';
        }
      };
      this.props.openAlertModal({
        body: (
          <p>{getMessage(newProps.api_error)}</p>
        ),
        confirmText: '閉じる',
        useCancel: false,
      });
    }
  }

  onLogin(e) {
    e.preventDefault();
    console.log('onLogin');
    this.props.showLoadingSpinner();
    this.props.login(this.state.organization, this.state.email, this.state.password);
  }

  onChangePasswordVisible(e) {
    this.setState({ password_visible: e.target.checked });
  }

  onChangeEmail(e) {
    this.setState({ email: e.target.value });
  }

  onChangeOrganization(e) {
    this.setState({ organization: e.target.value });
  }

  onChangePassword(e) {
    this.setState({ password: e.target.value });
  }

  render() {
    return (
      <OnePane>
        <div>
          <Alert color="success" isOpen={this.state.isAlreadyRegistered === 'true'}>
            <p>管理ユーザの登録が完了しました。以下のフォームからログインしてください。</p>
            <p>ログイン情報について不明な場合は招待メール内の「2.管理画面へのログイン方法」の項目を確認してください。</p>
          </Alert>
          <Form method="post" onSubmit={this.onLogin.bind(this)}>
            {this.env !== 'production' ? <LabelText>テスト環境 ({this.env})</LabelText> : null}
            <FormGroup>
              <Label for="organization">組織コード</Label>
              <Input
                type="text"
                id="organization"
                placeholder="組織コード"
                value={this.state.organization}
                onChange={this.onChangeOrganization.bind(this)}
                required
                />
            </FormGroup>
            <FormGroup>
              <Label for="email">Eメールアドレス</Label>
              <Input
                type="email"
                id="email"
                placeholder="Eメールアドレス"
                value={this.state.email}
                onChange={this.onChangeEmail.bind(this)}
                required
                />
            </FormGroup>
            <FormGroup>
              <Label for="password">パスワード</Label>
              <Input
                type={this.state.password_visible ? 'text' : 'password'}
                id="password"
                placeholder="パスワード"
                value={this.state.password}
                onChange={this.onChangePassword.bind(this)}
                required
                />
              <Input
                type="checkbox"
                id="password_visible"
                style={{ margin: '0', position: 'relative', cursor: 'pointer' }}
                checked={this.state.password_visible}
                onChange={this.onChangePasswordVisible.bind(this)}
                />
              <Label style={{ marginTop: '10px', marginLeft: '5px' }} for="password_visible">
                パスワードを表示
              </Label>
            </FormGroup>
            <Button type="submit" color="primary">ログイン</Button>
            <div style={{ marginTop: '10px' }}>
              <Link to="/reset">パスワードを忘れた場合はこちらから再設定できます。</Link>
            </div>
          </Form>
        </div>
      </OnePane>
    );
  }
}

const mapStateToProps = state => ({
  api_error: state.apiError.error,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  login,
  showLoadingSpinner,
  hideLoadingSpinner,
  openAlertModal,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Login);
